import React, { useEffect, useState } from "react";
import axios from "axios";
import "./Admin.css";

const AdminDashboard = () => {

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadDashboard();
  }, []);

  const loadDashboard = async () => {
    try {

      const res = await axios.get(
        "/api/admin/player-dashboard"
      );

      setData(res.data);

    } catch (err) {

      console.error("Dashboard Error:", err);

    } finally {

      setLoading(false);

    }
  };

  if (loading) {
    return (
      <div className="admin-dashboard">
        <h2>Loading Dashboard...</h2>
      </div>
    );
  }

  if (!data) {
    return (
      <div className="admin-dashboard">
        <h2>Failed to load dashboard data.</h2>
      </div>
    );
  }

  return (
    <div className="admin-dashboard">

      <h1 className="admin-title">
        Player Analytics Dashboard
      </h1>

      {/* USER STATS */}

      <div className="stats-grid">

        <div className="stat-card">
          <h3>Total Users</h3>
          <p>{data.users.totalUsers}</p>
        </div>

        <div className="stat-card">
          <h3>Active Users</h3>
          <p>{data.users.activeUsers}</p>
        </div>

        <div className="stat-card">
          <h3>Inactive Users</h3>
          <p>{data.users.inactiveUsers}</p>
        </div>

      </div>

      {/* TESTS */}

      <div className="tests-section">

        <h2>Tests Overview</h2>

        <div className="test-grid">

          <div className="test-card">
            <h4>Reaction Speed</h4>
            <p>{data.tests.reactionSpeed}</p>
          </div>

          <div className="test-card">
            <h4>Complex Reaction</h4>
            <p>{data.tests.complexReaction}</p>
          </div>

          <div className="test-card">
            <h4>Anticipation</h4>
            <p>{data.tests.anticipation}</p>
          </div>

          <div className="test-card">
            <h4>Short Term Memory</h4>
            <p>{data.tests.shortTermMemory}</p>
          </div>

          <div className="test-card">
            <h4>Working Memory</h4>
            <p>{data.tests.workingMemory}</p>
          </div>

          <div className="test-card">
            <h4>Search Span</h4>
            <p>{data.tests.searchSpan}</p>
          </div>

          <div className="test-card">
            <h4>Visual Acuity</h4>
            <p>{data.tests.visualAcuity}</p>
          </div>

          <div className="test-card">
            <h4>Color Vision</h4>
            <p>{data.tests.colorVision}</p>
          </div>

          <div className="test-card">
            <h4>Hand Eye Response</h4>
            <p>{data.tests.handEyeResponse}</p>
          </div>

          <div className="test-card">
            <h4>Hand Eye Coordination</h4>
            <p>{data.tests.handEyeCoordination}</p>
          </div>

          <div className="test-card">
            <h4>Contrast Sensitivity</h4>
            <p>{data.tests.contrastSensitivity}</p>
          </div>

        </div>

      </div>

    </div>
  );
};

export default AdminDashboard;